import { SET_IS_PERMISSION_CHECKED } from '@store/action-types/check-permission';

const setIsPermissionChecked = screenName => ({ type: SET_IS_PERMISSION_CHECKED, payload: { screenName } });

export default setIsPermissionChecked;
